export default __webpack_public_path__ + "static/media/vi.b64ddd4f.svg";